import { useState, type FormEvent } from "react";

import { api, ApiClientError } from "../api.js";

export function loginErrorMessage(caught: unknown): string {
  if (
    caught instanceof ApiClientError &&
    caught.code === "invalid_admin_password"
  ) {
    return "INVALID CODE";
  }
  return caught instanceof Error ? caught.message : String(caught);
}

export function LoginPage({ onSuccess }: { onSuccess(): void }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event: FormEvent): Promise<void> => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.login(password);
      setPassword("");
      onSuccess();
    } catch (caught) {
      setError(loginErrorMessage(caught));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-screen">
      <section className="login-panel">
        <form onSubmit={(event) => void submit(event)}>
          <label className="field">
            <input
              type="password"
              aria-label="Пароль"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </label>
          {error ? <div className="login-error">{error}</div> : null}
          <button
            className="button button--primary"
            disabled={loading || password.length === 0}
          >
            {loading ? "ПРОВЕРКА…" : "ВОЙТИ"}
          </button>
        </form>
      </section>
    </main>
  );
}
